<template>
  <div class="gmzlr">
    <div v-show="!dialogFormVisible" class="gmsqlb">
      <div class="headershenqing">
        <div class="headershenqinginside">
          <el-form
            :model="formInline"
            class="demo-form-inline"
            style="display: flex; height: 39px"
            label-width="90px"
            label-position="left"
          >
            <el-form-item label="许可证编号:">
              <el-input
                v-model="formInline.bianhao"
                placeholder="请输入"
              />
            </el-form-item>

            <el-form-item label="申请日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="formInline.sqKs"
                  type="date"
                  style="width: 100%"
                  placeholder="开始日期"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="formInline.sqJs"
                  type="date"
                  style="width: 100%"
                  placeholder="结束日期"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>
            <el-button
              v-preventReClick
              type="primary"
              icon="el-icon-search"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
          </el-form>
        </div>
      </div>
      <div class="tableGMZ">
        <div class="tableinside">
          <div class="addmessheader">
            <el-button
              v-preventReClick
              type="primary"
              icon="el-icon-plus"
              class="addmess"
              size="mini"
              @click="addMes"
            >录入</el-button>
            <!-- <el-button
              icon="el-icon-upload"
              v-preventReClick
              @click="dcexcel"
              size="mini"
              class="addmessedit"
              >导出</el-button
            > -->
          </div>
          <el-table
            ref="gmsqTable"
            :data="tableData"
            style="width: 100%"
            border
            :cell-style="typeStyle"
            show-overflow-tooltip
            @selection-change="handleSelectionChange"
            @select-all="checkSelect"
          >
            <el-table-column
              type="selection"
              align="center"
              :max="1"
              :min="1"
            />
            <el-table-column
              label="许可证编号"
              align="center"
              show-overflow-tooltip
              width="200"
            >
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.xkzBh }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="化学品名称"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.hxpMc }}</span>
              </template>
            </el-table-column>
            <el-table-column label="购买数量" align="center">
              <template slot-scope="scope">
                <span
                  size="medium"
                >{{ scope.row.hzsl + "("
                }}{{ scope.row.hzslDwMc + ")" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="用途" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.yt }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="销售单位"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.xsdwMc }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="申请时间"
              align="center"
              prop="sqsj"
              show-overflow-tooltip
            />
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.ztMc }} </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250px" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  size="mini"
                  type="primary"
                  icon="el-icon-view"
                  style="width: 65px; padding: 7px 9px"
                  @click="handleSelect(scope.$index, scope.row)"
                >查看</el-button>
                <!-- <el-button
                  v-if="scope.row.zt == '00'"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  style="width: 65px; padding: 7px 9px"
                  v-preventReClick
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  v-if="scope.row.zt == '00'"
                  size="mini"
                  icon="el-icon-close"
                  style="
                    background: #ff4c00;
                    color: #fff;
                    width: 65px;
                    padding: 7px 9px;
                  "
                  v-preventReClick
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
                <el-button
                  v-if="scope.row.zt == '12'"
                  size="mini"
                  style="
                    background: #4170ff;
                    color: #fff;
                    width: 65px;
                    padding: 7px 9px;
                  "
                  v-preventReClick
                  @click="handlehexiao(scope.$index, scope.row)"
                  >核销</el-button
                >

                <el-button
                  type="primary"
                  v-if="scope.row.zt == '42'"
                  size="mini"
                  style="background: #4170ff; padding: 7px 9px; width: 74px"
                  v-preventReClick
                  @click="handlecancel(scope.$index, scope.row)"
                  >取消核销</el-button
                >
                <el-button
                  v-if="scope.row.zt == '12'"
                  size="mini"
                  type="primary"
                  style="width: 65px; padding: 7px 9px"
                  v-preventReClick
                  @click="handledy(scope.$index, scope.row)"
                  >打印</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <gmzlr-tk
      v-if="dialogFormVisible"
      ref="dialoggmsq"
      :gmsqtype="type"
      :leixing="liexing"
      @close-dialog="closeDialog"
    />
  </div>
</template>
<script>
// 获取接口地址
import {
  getgmzDetailMes,
  exportMes,
  DeletegmzMes,
  hxgmzMes, downloadPdf
} from '@/assets/js/common.js'
import { getgmzMes } from '@/assets/js/gmzlr.js'
import gmzlrTk from './gmzlrTk.vue'

export default {
  name: 'GmzlrBody',
  components: { gmzlrTk },
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.formInline.sqJs) {
            return time.getTime() > new Date(this.formInline.sqJs).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.formInline.sqKs) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.formInline.sqKs).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      // 搜索条件
      formInline: {
        bianhao: '',
        sqKs: '',
        sqJs: ''
      },
      type: false, // 添加和编辑，可编辑，查看不可编辑
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 总条数
      tableData: [], // 表格数据
      dialogFormVisible: false, // 两个组件的切换
      detailMes: {}, // 编辑或查看每条数据的信息
      rowid: '',
      liexing: ''
    }
  },
  created() {
    // 获取列表信息
    this.search()
  },
  methods: {
    // 根据状态改变单元格字体颜色
    typeStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 7) {
        switch (row.zt) {
          case '00': // 草稿
            cellStyle = 'color:#333;font-weight:bold '
            break
          case '11': // 审批中
            cellStyle = 'color:#43A4E2;font-weight:bold '
            break
          case '12': // 已通过
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '13': // 不通过
            cellStyle = 'color:red;font-weight:bold '
            break
          case '22': // 已撤销
            cellStyle = 'color:red;font-weight:bold '
            break
          case '42': // 已核销
            cellStyle = 'color:red;font-weight:bold '
            break
          case '43': // 取消核销中
            cellStyle = 'color:red;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    checkSelect(selection) {
      this.$refs.gmsqTable.clearSelection()
    },
    // 根据列表id获取每条详细信息
    async getgmzDetailMess(data, type) {
      var ret = await getgmzDetailMes(data)
      this.detailMes = ret.data.data
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dialoggmsq.getformMes(this.detailMes, type)
      })
    },
    // 获取购买申请表信息
    getgmzMess(dataObj) {
      getgmzMes(dataObj).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 点击搜索时
    search() {
      this.getgmzMess({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          xkzBh: this.formInline.bianhao,
          beginTime: this.formInline.sqKs,
          endTime: this.formInline.sqJs
        }
      })
    },
    // 查看
    handleSelect(index, row) {
      // this.getgmzDetailMess(row.id);
      this.dialogFormVisible = true
      getgmzDetailMes(row.id).then((e) => {
        this.$refs.dialoggmsq.form = e.data.data
        this.$refs.dialoggmsq.xsdwLyList = e.data.data.xsdwLy.split(',')
      })
      this.liexing = 'view'
      this.type = true
    },
    // 点击申请按钮
    addMes() {
      this.dialogFormVisible = true
      this.type = false
      this.liexing = 'sq'
    },
    // 关闭对话框
    closeDialog() {
      this.dialogFormVisible = false // 切换组件为列表页
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    },
    /* 以下方法暂时没用 */

    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.gmsqTable.clearSelection()
        this.$refs.gmsqTable.toggleRowSelection(val.pop())
      }
    },
    // 编辑
    handleEdit(index, row) {
      this.getgmzDetailMess(row.id) // 根据id获取详细信息
      this.type = false
      this.liexing = 'edit'
    },
    // 打印
    handledy(index, row) {
      window.location.href = downloadPdf(row.xkzBh, row.id)
    },
    // 点击导出按钮
    dcexcel() {
      exportMes({
        xkzBh: this.formInline.bianhao,
        beginTime: this.formInline.sqKs,
        endTime: this.formInline.sqJs
      }).then((e) => {
        const table = '购买证报表'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 核销
    handlehexiao(index, row) {
      this.rowid = row.id
      this.$confirm('是否确认核销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        hxgmzMes(this.rowid).then((e) => {
          this.$message.success('核销成功')
          this.search()
        })
      })
    },
    // 取消核销
    handlecancel(index, row) {
      this.getgmzDetailMess(row.id)
      this.type = true
      this.liexing = 'qxhx'
    },
    // 删除行数据
    handleDelete(index, row) {
      this.$confirm('确认是否删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          DeletegmzMes(row.id).then((e) => {
            this.$message.success('删除成功')
            this.search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

.gmzlr {
  margin: 0 auto;
  margin-top: 35px;

  .el-button--primary {
    color: #fff;
    background-color: #4170ff;
    border-color: #4170ff;
  }

  /deep/ .el-pagination__total {
    margin-left: 8px;
  }
  .el-pagination {
    padding: 10px 0;
    border: 1px solid #ebeef5;
    border-top: 0;
  }
  .gmsqlb {
    padding-bottom: 10px;
    margin: 0 auto;
    width: 95%;
    max-width: 1503px;
    .headershenqing {
      display: flex;
      align-items: center;
      margin: 0 auto;
      height: 96px;
      background-color: #fff;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      margin-bottom: 10px;
      .headershenqinginside {
        margin: 0 auto;
        width: 90%;
        /deep/ .el-button {
          height: 39px;
          border-radius: 20px;
        }
        /deep/ .el-form-item {
          margin-bottom: 10px;
          margin-right: 30px;
        }
      }
    }

    .tableGMZ {
      background-color: #fff;
      // margin: 21px auto 57px auto;
      .tableinside {
        width: 90%;
        margin: 0 auto;
        padding: 40px 0 57px;
        /deep/ .el-table {
          z-index: 0;
        }
        /deep/ .el-table .has-gutter tr th {
          background: #f4f4f4;
        }
        .addmessheader {
          background: #f4f4f4;
          .addmess {
            margin: 12px 0 12px 8px;
          }
        }
      }
    }

    .el-dialog {
      .el-dialog__footer {
        .el-button {
          margin: 0 20px;
        }
      }
    }
  }
}
/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
</style>
